// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3PL9w","title":"ClientInsurance_title__2hG_S","itemText":"ClientInsurance_itemText__2gjLS"};